<div class="user-balances" [ngClass]="{ 'kids-balance': isKid }">
  <!--Points Balance-->
  <div class="balance-widget bg-glass-dark" [ngClass]="{ 'kids-balance-points': isKid }">
    <ng-container *notInPopulation="[population.Kids]"> 
      <div class="balance-details">
        <span class="icon material-icons">loyalty</span>
        <div class="balance">
          <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
          <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
        </div>
      </div>
    </ng-container>
    <ng-container *inPopulation="[population.Kids]">
      <div class="balance-details">
        <div class="font-size-12 me-1">{{ 'member.card.points.balance' | translate }}</div>
        <div class="balance">
          <span class="icon material-icons">loyalty</span>
          <h5 class="mb-0">{{ pointsBalance$ | async }}</h5>
        </div>
      </div>
    </ng-container>
  </div>

  <!--eCash Balance-->
  <ng-container *notInPopulation="[population.Kids]">
    <div class="balance-widget bg-glass-dark cursor-pointer" [routerLink]="'/hawksbucks'">
      <div class="balance-details">
        <span class="icon material-icons material-symbols-outlined money-bag-icon">money_bag</span>
        <div class="balance">
          <h5 class="mb-0">{{ ecash$ | async | FortressCurrencyPipe }}</h5>
          <div class="font-size-12 me-1">{{ 'member.card.ecash.balance' | translate }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
